import { apiGet, apiPost } from './client';
import type { Leaderboard, LeaderboardSort, MockTestAttemptDetail, MockTestAttemptSummary, MockTestDetail, MockTestSummary } from './mockTest.types';

export const mockTestApi = {
  list: () => apiGet<MockTestSummary[]>('/mock-tests'),
  get: (mockTestId: string) => apiGet<MockTestDetail>(`/mock-tests/${mockTestId}`),
  /** Chấm cả bài một lần; `answers` chỉ gồm câu đã chọn, câu trống tính 0 điểm. */
  submit: (mockTestId: string, body: { displayName: string; answers: { order: number; picked: number }[]; partSeconds: number[] }) =>
    apiPost<MockTestAttemptDetail>(`/mock-tests/${mockTestId}/attempts`, body),
  listAttempts: (mockTestId: string) => apiGet<{ items: MockTestAttemptSummary[] }>(`/mock-tests/${mockTestId}/attempts`),
  getAttempt: (attemptId: string) => apiGet<MockTestAttemptDetail>(`/mock-tests/attempts/${attemptId}`),
  leaderboard: (mockTestId: string, sort: LeaderboardSort) => apiGet<Leaderboard>(`/mock-tests/${mockTestId}/leaderboard?sort=${sort}`),
};
